var map = {
	"./corazon_azul.webp": "zZ+K",
	"./corazon_lila.webp": "3Frs",
	"./corazon_rojo.webp": "MewH",
	"./corazon_rosa.webp": "cmmo",
	"./corazon_violeta.webp": "UEdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J3c+";